export const ANIMATION_WORDS = ["search", "plan", "book", "live", "love"];
